import {Typography} from "@mui/material";
import {Outlet} from "react-router-dom";


const TeamsRoute = () => {
    return (
        <Outlet/>
    )
}

export default TeamsRoute;